"use strict";

function helper(Handlebars) {
  /**
   * Perform a rendering a specific number of times.
   * Passes the current index back to the Handlebars function.
   *
   * @param  {Number} n    Name of iterations
   * @param  {Object} block 'block' object sent by handlebars
   * @return {String} html structure
   */
  function times(n, block) {
    var accum = '';
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < n; ++i) {
      accum += block.fn({
        index: i
      });
    }
    return accum;
  }
  Handlebars.registerHelper('times', times);
  return times;
}
module.exports = helper;
